import React from "react";

import { Button, EmptyState, NotificationSnackbar, SectionCard } from "shared/ui";

import { BadgeDialog } from "features/MenuItemBadges/components/BadgeDialog";
import { BadgesList } from "features/MenuItemBadges/components/BadgesList";
import { DeleteBadgeDialog } from "features/MenuItemBadges/components/DeleteBadgeDialog";
import { MenuItemBadgesContext } from "features/MenuItemBadges/context";
import { useMenuItemBadgesState } from "features/MenuItemBadges/hooks/useMenuItemBadgesState";

import { Container } from "./styles";

export const MenuItemBadges = () => {
    const state = useMenuItemBadgesState();

    if (state.loading) {
        return <Container>Загрузка бейджей…</Container>;
    }

    if (state.error) {
        return <Container>Не удалось загрузить бейджи</Container>;
    }

    return (
        <MenuItemBadgesContext.Provider value={state}>
            <Container>
                <SectionCard
                    title="Бейджи позиций"
                    description="Отметки на карточках меню: «Острый», «Хит», «Новинка» и любые свои. Бейдж создаётся один раз и проставляется позициям в их редакторе"
                    headerRight={<Button onClick={state.openCreateDialog}>Добавить бейдж</Button>}
                >
                    {state.badges.length === 0 ? (
                        <EmptyState
                            title="Бейджей пока нет"
                            description="Бейдж помогает гостю выбрать: подскажет остроту, состав или популярность блюда. Создайте первый — и отметьте им позиции."
                            action={<Button onClick={state.openCreateDialog}>Добавить бейдж</Button>}
                        />
                    ) : (
                        <BadgesList />
                    )}
                </SectionCard>

                <BadgeDialog
                    open={state.isBadgeDialogOpen}
                    badge={state.editedBadge}
                    locale={state.locale}
                    availableLanguages={state.availableLanguages}
                    saving={state.saving}
                    onClose={state.closeBadgeDialog}
                    onSubmit={state.submitBadge}
                />
                <DeleteBadgeDialog />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </MenuItemBadgesContext.Provider>
    );
};
